import React from "react";

const Credits = () => {
  return (
    <footer>
      <span className="credit">
        Made with ❤️ by
        <a
          href="https://github.com/mafzaldev"
          target="_blank"
          className="credit"
          rel="noreferrer"
        >
          @mafzaldev
        </a>
      </span>
    </footer>
  );
};

export default Credits;
